import { USER_LOGIN, GET_PROFILE,AUTHENTICATION,GET_DASHBOARD_COUNT, USER_BY_ID } from "./type";

const initialState = {
  userData: {},
  authenticated: false,
  userProfile: {},
  dasboardCount: [],
  userDetailsById:[]
};

const loginReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_LOGIN:
      return {
        ...state,
        userData: payload,
      };
    case AUTHENTICATION :
      return{
        authenticated:payload,
      };
    case GET_PROFILE:
      return {
        ...state,
        userProfile: payload,
      };
    case GET_DASHBOARD_COUNT:
        return {
          ...state,
          dasboardCount: payload,
      };
    case USER_BY_ID:
      return {
        ...state,
        userDetailsById: payload,
      };
    default:
      return { ...state };
  }
};

export default loginReducer;
